import defaultState from '../state/defaultState'
import filterOptions from './filterOptions'

const update = (props, state) => {
  if (state.get(`selectr.${props.name}`)) {
    state.set(`selectr.${props.name}`, {
      options: filterOptions(props.options, false),
      selected: filterOptions(props.options, true),
      createTags: props.createTags,
      payload: props.payload,
      ...defaultState
    })
  }
}

export default update
